import { useEffect, useState } from "react";
import client from "@/api/client";

export function useTransportRefData() {
  const [sites, setSites] = useState([]);
  const [rigs, setRigs] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    Promise.all([
      client.get("/site-master/sites", { params: { all: true } }),
      client.get("/assets"),
      client.get("/employees", { params: { employment_status: "Active", all: true } }),
    ])
      .then(([s, a, e]) => {
        if (!active) return;
        setSites(s.data);
        setRigs(a.data);
        setEmployees(e.data);
      })
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, []);

  return { sites, rigs, employees, loading };
}
